<template>
<div class="container-fluid footer" id="footer">

  <div class="row mt-5">

    <div class="container">
      <div class="row mt-5">
        <div class="col-md-4  align-self-center center pt-2 pr-0 pb-3">

          <div class="container-fluid">
            <div class="row justify-content-center">

              <!--<div class="col-7 col-md-5  align-self-center center pt-2 pr-0 ">
            <img class="img-fluid widthFull" src="../../assets/images/logo_green.png">
          </div>
          <div class="col-md-7  align-self-center center pt-4 black pl-0">
            <h3>Comfort for my home</h3>
          </div>-->

              <div class="col-md-12  align-self-center text-left ">
                <!--
            <h5 class="black Bold  text-left pb-3 pt-3" style="line-height: 30px;">© {{moment().format('YYYY')}} Vaillant I Vaillant Group Italia SpA
              Cap. Soc. EUR 9.300.000 Int. Vers
              <br /> P.IVA 09613720151
              N. Registro AEE: IT08020000003755
            </h5>
            -->
                <h5 class="black   text-left pb-0 " style="line-height: 20px;">
                  <b class="pb-3 widthFull">Powered by NOVATAG S.R.L.</b>
                </h5>

                <h5 class="black   text-left pb-0 " style="line-height: 30px;">
                  © {{moment().format('YYYY')}} Cap. Soc. EUR 81.0<router-link to="/cobrowsing" class="black p-0 m-0">0</router-link>0,00 Int. Vers.
                  <br /> P.IVA 09012690963
                  REA MI 2062710
                </h5>



              </div>
            </div>
          </div>

        </div>
        <div class="col-md-2  align-self-end text-left pt-0 pr-0 pb-2 pb-md-4 mb-1"></div>
        <div class="col-md-2  align-self-end text-left pt-0 pr-0 pb-2 pb-md-4 mb-1">
          <a v-if="brand == 'CHEBONUS'" href="https://storage.googleapis.com/chebonus/Privacy.pdf?v=2" target="_blank" class="grey pl-4 pl-md-2">
            <b>Privacy Policy</b>
          </a>
          <a v-if="brand == 'HAPPYBONUS'" href="https://storage.googleapis.com/happybonus/Privacy.pdf?v=2" target="_blank" class="grey pl-4 pl-md-2">
            <b>Privacy Policy</b>
          </a>
        </div>
        <div class="col-md-2  align-self-end text-left pt-0 pr-0 pb-2 pb-md-4 mb-1">
          <a v-if="brand == 'CHEBONUS'" href="https://storage.googleapis.com/chebonus/Cookie.pdf" target="_blank" class="grey pl-4 pl-md-2">
            <b>Cookie Policy</b>
          </a>
          <a v-if="brand == 'HAPPYBONUS'" href="https://storage.googleapis.com/happybonus/Cookie.pdf" target="_blank" class="grey pl-4 pl-md-2">
            <b>Cookie Policy</b>
          </a>
        </div>
        <div class="col-md-2  align-self-end text-left pt-0 pr-0 pb-2 pb-md-4 mb-1">
          <a v-if="brand == 'CHEBONUS'" href="https://storage.googleapis.com/chebonus/Conditions.pdf?v=2" target="_blank" class="grey pl-4 pl-md-2">
            <b>Termini di utilizzo</b>
          </a>
          <a v-if="brand == 'HAPPYBONUS'" href="https://storage.googleapis.com/happybonus/Conditions.pdf?v=2" target="_blank" class="grey pl-4 pl-md-2">
            <b>Termini di utilizzo</b>
          </a>
        </div>
        <!--
    <div class="col-md-2  align-self-center center pt-2 pr-0 "></div>
    <div class="col-md-2  align-self-center center pt-5 mt-5 pr-0 ">




      <div class="footer__social">
        <ul class="social">
          <li class="social__facebook"><a target="_blank" href="https://www.facebook.com/VaillantItalia?fref=ts"
              style="background-image:url(data:image/png;base64,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);"
              title="Facebook" data-ga-tracking="{ 'category': 'text', 'action': 'footer', 'label': 'facebook' }">Facebook</a></li>
          <li class="social__youtube"><a target="_blank" href="https://www.youtube.com/channel/UCeGvCY6dWa3g1oaloorovuA"
              style="background-image:url(data:image/png;base64,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);"
              title="Youtube" data-ga-tracking="{ 'category': 'text', 'action': 'footer', 'label': 'youtube' }">Youtube</a></li>
          <li class="social__linkedin"><a target="_blank" href="https://www.linkedin.com/company/vaillant-italia/"
              style="background-image:url(data:image/png;base64,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);"
              title="Linkedin" data-ga-tracking="{ 'category': 'text', 'action': 'footer', 'label': 'linkedin' }">Linkedin</a></li>
        </ul>
      </div>


    </div>

  -->
      </div>
    </div>
  </div>

</div>
</template>

<script>
import {
  mapGetters,
  mapState
} from 'vuex'
const moment = require('moment')

export default {
  name: 'sqreen-footer',
  data() {
    return {
      moment: moment,
      brand: process.env.BRAND,
    }
  },
  computed: {
    ...mapGetters(['getProfile', 'loginerror', 'loadingState', 'isAuthenticated', 'isProfileLoaded', 'authStatus', 'checkAge']),
    ...mapState({
      //response: state => `${state.status.response.data}`,
    })
  },
}
</script>

<style lang="css" scoped>

	.azzure{
		color: #0490a5!important;
	}

	.footer__social .social {

    padding: 0.1rem 0;
    display: block;
}
.social {
    margin: 0 -0.25rem;
    list-style: none;
    padding: 0;
    font-size: 0;
}
.footer__social .social [class^="social__"] {
    padding: 0 0.25rem 0.1rem;
    display: inline-block;
    float: none;
    font-size: 0;
}
.social>li>a {
    display: block;
    background-size: 100% 100%;
    text-indent: -99em;
    overflow: hidden;
    width: 32px;
    height: 32px;
}
	.footerText{
		font-size: 14px;
		margin-bottom: 0px;

	}

	.footerBrownDesc {
		color: #000000;
		font-family: museo-slab;
		font-size:16px
	}

	.footerImageRight{
		text-align: right;
	}

	.support{
		color: #000000;
		font-size: 16px;
	}

	.techImage{
		width: 90%;
	}

	.tech {
		position: absolute;
		top: -80px;
		left: -80px;
		font-size: small;
	}

	.bottomBrand{

		padding: 28px;
	}

	@media (min-width: 20px) and (max-width: 767px) {
		.footerImageRight{
			text-align: left;
		}
		.footerText{
			font-size: 12px;
			margin-bottom: 0px;
		}
		.tech {
			top: -100px;
		}

		.bottomBrand{
			width: 27vw;
			padding-top: 10px;
			padding: 10px;
		}

		.footer {
			margin-top: -306px;
	     height: auto;
		}

		.alignBottomMobile{
			align-self: flex-end;
		}

		.techImage {
			width: 59%;
		}

		.tech {
			top: -60px;
			left: -57px;
			width: 172px;
		}

		.footerBrownDesc[data-v-62fe346e] {
			color: #000000;
			font-family: museo-slab;
			font-size: 13px;
		}

		.support[data-v-62fe346e] {
			color: #000000;
			font-size: 11px;
		}

	}



</style>



// WEBPACK FOOTER //
// src/components/footer/index.vue